export default __webpack_public_path__ + "locales/cs/Common.json?hash=4b1ffd719c3ac60aff33734f7025cdf0";